import { OptionType } from '../plan/option-type';
import { IValidation } from '../validation/validation';
import { ISpecifiedItemInput } from './specified-item-input';

export interface ISpecifiedItemOptionInput {
  optionType: OptionType.SpecifiedItems;
  specifiedItems: ISpecifiedItemInput[];
  validation?: IValidation;
}

export const emptySpecifiedItems: ISpecifiedItemOptionInput = {
  optionType: OptionType.SpecifiedItems,
  specifiedItems: [],
};
